import { render, staticRenderFns } from "./Section2.vue?vue&type=template&id=c3ac5600"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"
import style0 from "./Section2.vue?vue&type=style&index=0&id=c3ac5600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports